<template>
  <div class="children-activities">
    <div class="row">
      <div class="col-sm-3">
        <h3 style="margin-top: 4px;">
          week {{ this.$moment(dateStart).format('W') }}
          <span v-if="$moment(dateStart).format('YYYY') !== $moment().format('YYYY')">
            {{ $moment(dateStart).format('YYYY') }}
          </span>
        </h3>
      </div>
      <div class="col-sm-9 text-end">
        <date-range-select type="week" @changeDateRange="getActivities(selectedChild, $event.dateStart, $event.dateEnd)"></date-range-select>
      </div>
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div v-if="isLoading">
      <p class="text-center" style="margin: 50px">
        Laden...
      </p>
    </div>
    <div v-if="dates && isLoading === false">
      <div v-bind:key="index" v-for="(date, index) in dates">
        <p>{{ this.$moment(date).format('dddd D MMMM') }}</p>
        <hr>
        <div v-if="activities && activities.length > 0 && getActivitiesWithDate(activities, date).length > 0" style="margin-bottom: 5px">
          <div v-bind:key="key" v-for="(activity, key) in activities">
            <span v-if="date === activity.date">
              <activity-list-item :activity="activity" :divider="true"></activity-list-item>
            </span>
          </div>
        </div>
        <div v-else>
          <p class="text-center">Geen activiteiten</p>
          <hr>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangeSelect from '@/components/Date-Range-Select'
import ActivityListItem from '@/components/Activity-List-Item'
export default {
  name: 'children-activities',
  components: {
    DateRangeSelect,
    ActivityListItem
  },
  data () {
    return {
      isLoading: false,
      activities: null,
      dateStart: null,
      dateEnd: null,
      dates: null
    }
  },
  created () {
    this.dateStart = this.$moment().startOf('week').format('YYYY-MM-DD')
    this.dateEnd = this.$moment().endOf('week').format('YYYY-MM-DD')
    this.dates = this.getDates(this.dateStart, this.dateEnd)
    this.getActivities(this.selectedChild, this.dateStart, this.dateEnd)
  },
  methods: {
    getDates (dateStart, dateEnd) {
      dateStart = this.$moment(dateStart).startOf('isoweek')
      dateEnd = this.$moment(dateEnd).endOf('isoweek')
      var now = dateStart.clone()
      var dates = []
      while (now.isBefore(dateEnd) || now.isSame(dateEnd)) {
        dates.push(now.format('YYYY-MM-DD'))
        now.add(1, 'days')
      }
      return dates
    },
    getActivities (child, dateStart, dateEnd) {
      this.dateStart = dateStart
      this.dateEnd = dateEnd
      this.dates = this.getDates(dateStart, dateEnd)
      this.isLoading = true
      this.$request.get('/activities?id_child=' + child.id + '&date=' + dateStart + '&up_to_date=' + dateEnd)
      .then((response) => {
        this.isLoading = false
        if (response.data) {
          this.activities = response.data
        }
      })
    },
    getActivitiesWithDate (activities, date) {
      var activitiesWithDate = []
      for (var i = 0; i < activities.length; i++) {
        if (activities[i].date === date) {
          activitiesWithDate.push(activities[i])
        }
      }
      return activitiesWithDate
    }
  }
}
</script>

<style scoped>
</style>
